module.exports = __webpack_public_path__ + "static/media/Cross-Up.39c96fa1.png";